module.exports = {"422802001":"都亭街道","422802002":"东城街道","422802100":"谋道镇","422802101":"柏杨坝镇","422802102":"汪营镇","422802103":"建南镇","422802104":"忠路镇","422802105":"团堡镇","422802106":"毛坝镇","422802107":"文斗镇","422802200":"凉雾乡","422802201":"元堡乡","422802202":"南坪乡","422802205":"沙溪乡","422802401":"佛宝山生态综合开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422802.json
// module id = 1917
// module chunks = 0